
<div *ngIf="verifyBOD">
<div >
            <div class="pb-2">
              <img class="logo-img logo-img-lg" [src]="logo" alt="logo">
            </div>
            <div class="nk-block-head start-survey-title">
              <div class="nk-block-head-content">
                <h1 class="nk-block-title">{{getLabel()}}</h1>
              </div>
            </div>
            <div class="col-md-12 centered text-center">
              <div class="col-md-12" *ngIf="multipleLanguage" style="float:right">
                <div class="col-sm-2 float-end">
                  <select id="language" name="idLanguage" class="form-control csc-select"  (change)="changeLanguage()" [(ngModel)]="languageId">
                    <option *ngFor="let l of languages" [ngValue]="l.idLanguage">{{l.name}}</option>
                  </select>
                </div>
              </div>
              <div class="row insert-date">
                <div class="col-md-12 col-lg-4">
                  <select  [(ngModel)]="birthDate.month" class="csc-select dob-select">
                    <option [ngValue]="null" disabled>{{'Month'| translate}}</option>
                    <option *ngFor="let month of monthsArr" [ngValue]="month">{{month | translate}}</option>
                  </select>
                </div>
                <div class="col-md-12 col-lg-4">
                  <select [(ngModel)]="birthDate.day" class="csc-select dob-select">
                    <option [ngValue]="null" disabled>{{'Day'| translate}}</option>
                    <option *ngFor="let day of daysArr" [ngValue]="day">{{day}}</option>
                  </select>
                </div>
                <div class="col-md-12 col-lg-4">
                  <select [(ngModel)]="birthDate.year" class="csc-select dob-select">
                    <option [ngValue]="null" disabled>{{'Year'| translate}}</option>
                    <option *ngFor="let year of yearsArr" [ngValue]="year">{{year}}</option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div >
                  <button (click)="onClickDate()" type="button" class="btn next-button">{{'Next' | translate}}</button>
                </div>
              </div>

            </div>


            <div class="form-note-s2 text-right pt-4">
              <a routerLink='/login' class="return-to-login"><strong>{{'Return to login' | translate}}</strong></a>
            </div>

    </div>
</div>



<!--
<div class="nk-app-root">
  <div class="nk-main">
    <div class="nk-wrap nk-wrap-nosidebar">
      <div class="nk-content ">
        <div class="nk-block nk-block-middle nk-auth-body  wide-xs">
          <div class="card">
            <div class="card-inner card-inner-lg">
              <div class="pb-2">
                <img class="logo-img logo-img-lg" [src]="logo" alt="logo">
              </div>
              <div class="nk-block-head">
                <div class="nk-block-head-content">
                  <h5 class="nk-block-title">Two factor authentication</h5>
                  <div class="nk-block-des">
                    <p>Enter the 6-digit code below</p>
                  </div>
                </div>
              </div>
              <form #form="ngForm" id="form" novalidate>
                <div class="row mt-3">
                  <div class="col-1"></div>
                  <div class="col">
                    <div class="form__pincode justify-content-center d-flex">

                    </div>
                  </div>
                  <div class="col-1"></div>
                </div>
                <div class="row d-flex justify-content-center mt-3">
                  <div class="col"></div>
                  <div class="col">
                  </div>
                  <div class="col"></div>
                </div>
                <div class="row d-flex justify-content-center mt-3">
                  <div class="col"></div>
                  <div class="col">
                    <div class="d-flex justify-content-center">
                      <a id="buttonResend" class="btn btn-xs btn-light"  onclick="this.style.opacity=0.3; this.style.cursor='not-allowed';">Resend Code</a>
                    </div>
                  </div>
                  <div class="col"></div>
                </div>
              </form>

              <div class="form-note-s2 text-left pt-4">
                <a routerLink='/login' id="return2Login"><strong>Return to login</strong></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

-->
